import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { AlertService } from '@app/core/alert/alert.service';
import { RecordPolicyService } from '@app/core/auth/permissions-policies';
import { DataService } from '@app/core/http/data.service';
import { DashboardDto } from '@app/shared/models/dashboard-model';
//import { ProjectDto } from '@app/shared/models/project-model';
import { MsalService } from '@azure/msal-angular';
import { first } from 'rxjs';
import { NavigationService, ListType } from '@app/core/http/navigation.service';
import { ProjectDto } from '@app/shared/models/project-model';
import { RouterModule } from '@angular/router';
import { MatTooltipModule } from '@angular/material/tooltip';
//import { CopilotChatComponent } from '../copilot-chat/copilot-chat.component';


@Component({
    selector: 'app-dashboard',
    templateUrl: 'dashboard.component.html',
    styleUrls: ['./dashboard.component.css'],
    standalone: true,
    imports: [CommonModule, RouterModule, MatTooltipModule, // LTBV Copilot CopilotChatComponent

    ]
})

export class DashboardComponent implements OnInit {
    readonly alertService = inject(AlertService);
    navigationService = inject(NavigationService);
    authService = inject(MsalService);
    dataService = inject(DataService);
    policy = inject(RecordPolicyService);

    dashboardDto = new DashboardDto();

    showCopilot = false;

    ngOnInit() {  
        this.dataService.getOne<DashboardDto>('General/GetDashboard').pipe(first()).subscribe(data => {
            this.dashboardDto = data
        }); 
    } 

    getCrewLocation(crew: any): string {
        if (!crew) {
            return 'Location not available';
        }
        const job = this.dashboardDto.openJobs.find(
            job => job.crewId === crew.id
        );
        return job?.locationDto?.name ?? 'Location not available';
    }

    getCustomerOpenJobs(customer: any): number {
        if (!customer) {
            return 0;
        }
        return this.dashboardDto.openJobs.filter(job => job.customerDto.id === customer.id).length;
    }

    goToList(project: ProjectDto, type: ListType) {
    
      const route = `/log${type.toLowerCase()}s`;
    
      this.navigationService.navigateToPage(
        route,
        { projectId: project.id },
        {
          crewId: project.crewDto?.id,
          statusId: project.status
        }
      );
    }

}


   